import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import Reveal from "@/components/feature/Reveal";
import { articles } from "@/mocks/melons";

type FeedItem = {
  articleSlug: string;
  articleTitle: string;
  topicName: string;
  at: string;
  title: string;
  detail: string;
};

const buildFeed = (): FeedItem[] => {
  const feed: FeedItem[] = [];
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));
  sorted.slice(0, 4).forEach((article) => {
    article.timeline.slice(-2).forEach((event) => {
      feed.push({
        articleSlug: article.slug,
        articleTitle: article.title,
        topicName: article.topicName,
        at: event.at,
        title: event.title,
        detail: event.detail,
      });
    });
  });
  return feed.slice(0, 6);
};

export default function TimelineStrip() {
  const feed = buildFeed();

  return (
    <section className="w-full py-14 md:py-20">
      <Container>
        <Reveal className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.22em] text-accent-700">最新时间线</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              这一刻，谁又落在了时间轴的哪一格
            </h2>
          </div>
          <Link
            to="/timeline"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
          >
            打开全网时间线
            <i className="ri-arrow-right-line"></i>
          </Link>
        </Reveal>
      </Container>

      <div className="mt-10 overflow-x-auto pb-4">
        <div className="mx-auto flex w-max gap-4 px-4 md:px-6">
          {feed.map((item, index) => (
            <Reveal key={`${item.articleSlug}-${index}`} delay={index * 60} className="w-[290px] shrink-0">
              <Link
                to={`/article/${item.articleSlug}`}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-400"
              >
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2 text-xs font-medium text-accent-700">
                    <span className="h-2 w-2 rounded-full bg-accent-500"></span>
                    {item.at}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
                    {item.topicName}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.detail}</p>
                <p className="mt-4 line-clamp-1 border-t border-background-100 pt-3 text-xs text-foreground-500">
                  出自 · {item.articleTitle}
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}